import script from "./PastReviewExamples.vue?vue&type=script&setup=true&lang=ts"
export * from "./PastReviewExamples.vue?vue&type=script&setup=true&lang=ts"

import "./PastReviewExamples.vue?vue&type=style&index=0&id=3b23c4d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b23c4d2"]])

export default __exports__